import React, { useState } from 'react';
import { supabase } from '../supabase';

export default function AuthPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error: e2 } = await supabase.auth.signInWithPassword({ email, password });
    if (e2) setError(e2.message);
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: 20
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{
            width: 52, height: 52, background: 'var(--accent)', borderRadius: 12,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: 'var(--font)', fontWeight: 800, fontSize: 26, color: '#fff',
            margin: '0 auto 16px'
          }}>L</div>
          <h1 style={{ fontFamily: 'var(--font)', fontSize: 22, marginBottom: 4 }}>Liongate CRM</h1>
          <p style={{ color: 'var(--text3)', fontSize: 13 }}>Sign in to your account</p>
        </div>

        <div className="card">
          <form onSubmit={login}>
            <div style={{ marginBottom: 14 }}>
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                autoFocus
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {error && (
              <div style={{
                background: 'var(--red-dim)', color: 'var(--red)', padding: '10px 14px',
                borderRadius: 'var(--radius)', fontSize: 13, marginBottom: 14
              }}>
                {error === 'Invalid login credentials' ? 'Incorrect email or password.' : error}
              </div>
            )}
            <button
              type="submit"
              className="btn-primary"
              style={{ width: '100%', padding: '11px', fontSize: 14 }}
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', color: 'var(--text3)', fontSize: 12, marginTop: 20 }}>
          No account? Contact your administrator.
        </p>
      </div>
    </div>
  );
}
